/**
 *
 * @file config.ts
 * @description Data grid configuration file
 */
export const dataGridConfig = {
  paginationModel: {
    pageSize: 10, // Records per page
    page: 0, // Current page
  },
  pageSizeOptions: [5, 10, 20, 30, 40, 50], // Records per page options
  sx: {
    "& .MuiTablePagination-root": {
      width: "100%",
    },
    "& .MuiTablePagination-spacer": {
      display: "none",
    },
  },
};
